import { useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config";

const ConnectStripe = () => {
  useEffect(() => {
    const connect = async () => {
      try {
        const res = await axios.post(
       `${API_BASE_URL}/api/stripe/connect`,
          {},
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        // 🔁 Redirect user to Stripe onboarding
        window.location.href = res.data.url;
      } catch (err) {
        console.error("Stripe connect failed", err);
        alert("Unable to start Stripe onboarding");
      }
    };

    connect();
  }, []);

  return <p style={{ textAlign: "center" }}>Redirecting to Stripe…</p>;
};

export default ConnectStripe;
